import React, { useEffect } from "react";
import { Text, Grid, GridItem, Image, Flex, Link, Button, List, ListItem, UnorderedList} from "@chakra-ui/react";


export default function ArtGallery() {
    
  useEffect(() => {
    // Prevent loading the script multiple times
    if (document.querySelector('script[src="https://w.behold.so/widget.js"]')) {
      return;
    }

    const script = document.createElement("script");
    script.src = "https://w.behold.so/widget.js";
    script.type = "module";
    script.async = true;

    document.head.appendChild(script);
  }, []);
    
  return (
    <div id="art">
      <Grid
        templateAreas={{
          lg: `"header body"
                    "header body"`,
          base: `"header"
              "body"`,
        }}
        gridTemplateRows={{ base: "6rem 1fr" }}
        gridTemplateColumns={{ base: "1fr 3fr" }}
        px={{md: "7rem", base: "3rem"}}
        overflow={"hidden"}
        pb="5rem"
        bg={{ lg: "transparent", base: "offwhite" }}
        gap="2rem"
        pl={{ lg: "8rem", base: "auto" }}
      >
        <GridItem area={"header"}>
          <Text
              variant={"subHeader"}
              textAlign={{  base: "center" }}
              lineHeight={"80%"}
              color="darkestgrey"
              mb="3rem"
            >
              Game Dev
            </Text>
             <Text variant="type" color="darkgrey">
                Aside from software engineering, I'm also an avid <b>artist</b>and <b>game developer</b>. I've <b>built 2D and 3D game engines</b> from scratch 
                (using Java and C++ respectively), as well as <b>created on custom shaders, concept art, and original assets</b> for my games. You can view more of my game-related work
                by clicking the link to the right!
              </Text>
        </GridItem>
        <GridItem
          area={"body"}
          display="flex"
          flexDir={{ lg: "column", base: "row" }}
          justifyContent={{ lg: "flex-start", base: "center" }}
          alignItems="center"
          height="100%"
          width="100%"
          gap="2rem"
        >
          <div data-behold-id="wM3M2d7RWLsfO6slzgAc"></div>
          <Link href={"https://www.instagram.com/jjessiart/"} target="_blank">
            <Button
              variant="solid"
              px="3rem"
              color="offwhite"
              bg="lightblue"
              _hover={{ bg: "black" }}
            >
              View more game dev work here!
            </Button>
          </Link>
        </GridItem>
      </Grid>
    </div>
  );
}
